import * as Sentry from '@sentry/browser';

type SentryInitOptions = {
  tracePropagationTargets?: Array<string | RegExp>;
  tracesSampleRate?: number;
};

type SentryUser = {
  id?: string;
  email?: string;
  username?: string;
  [key: string]: any;
};

export class SentryService {
  private dsn: string;
  private env: string;
  private release?: string;
  private denyUrls?: RegExp[]; // see https://docs.sentry.io/platforms/javascript/configuration/filtering/

  constructor(dsn: string, env?: string, denyUrls?: RegExp[], release?: string) {
    this.dsn = dsn;
    this.env = env || 'production';
    this.denyUrls = denyUrls;
    this.release = release;
  }

  public report = Sentry.captureException;

  public init = (options: SentryInitOptions = {}) => {
    const { tracePropagationTargets, tracesSampleRate } = options;
    const tracingEnabled = typeof tracesSampleRate === 'number' && tracesSampleRate > 0;

    Sentry.init({
      dsn: this.dsn,
      environment: this.env,
      release: this.release,
      denyUrls: this.denyUrls,
      ...(tracingEnabled
        ? {
            integrations: [
              Sentry.browserTracingIntegration({
                traceFetch: true,
                traceXHR: true,
                tracePropagationTargets,
              }),
            ],
            tracePropagationTargets,
            tracesSampleRate,
          }
        : {}),
    });
  };

  public captureException(err: any, context?: any) {
    Sentry.captureException(err, context);
  }

  public captureMessage(message: any) {
    Sentry.captureMessage(message);
  }

  public setUser(user: SentryUser | null) {
    Sentry.configureScope(scope => {
      scope.setUser(user);
    });
  }

  public clearUser() {
    this.setUser(null);
  }
}
